import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";

import store from "./data/store";
import App from "./App";

import "./Styles/index.scss";

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);
